var map = {
	"./fondo/textura-2.svg": "f904",
	"./imagenes_compartidas/12 boton saltar pregunta.svg": "d070",
	"./imagenes_compartidas/BOTON-ANTERIOR-OVER.svg": "690a",
	"./imagenes_compartidas/BOTON-ANTERIOR.svg": "9465",
	"./imagenes_compartidas/BOTON-SIGUIENTE-OVER.svg": "44e7",
	"./imagenes_compartidas/BOTON-SIGUIENTE.svg": "6a62",
	"./imagenes_compartidas/Boton-de-cierre.svg": "3b64",
	"./imagenes_compartidas/icon-descarga.svg": "2086",
	"./imagenes_compartidas/icon-ul-a.svg": "d73c",
	"./imagenes_compartidas/logo-ecopetrol.svg": "b7f7",
	"./imagenes_compartidas/menu-icon.svg": "f831",
	"./presentacion/1Fondoportada.svg": "71b3",
	"./presentacion/3 titulo portada.svg": "da0e",
	"./presentacion/4 boton inicio portada.svg": "ba18",
	"./presentacion/modulo-1.svg": "023d",
	"./presentacion/modulo-2.svg": "f8c7",
	"./presentacion/modulo-3.svg": "47b7",
	"./presentacion/modulo-4.svg": "ec3a",
	"./presentacion/modulo-5.svg": "aa771",
	"./unidad1/pantalla 6-1 mobile.svg": "5f94",
	"./unidad1/pantalla 6-3.svg": "1a6d",
	"./unidad1/pantalla 7-1 mobile.svg": "5b30",
	"./unidad2/Icono (1).svg": "c1f2",
	"./unidad2/boton Nuevamente.svg": "a118",
	"./unidad2/boton comprobar.svg": "6559",
	"./unidad2/pantalla 4-1 mobile.svg": "a607",
	"./unidad2/pantalla 4-1.svg": "6388",
	"./unidad2/pantalla 5-1.svg": "7569",
	"./unidad2/pantalla 5-4.svg": "07af",
	"./unidad2/pantalla 6-8.svg": "c876",
	"./unidad2/pantalla 7-1 mobile.svg": "f6d1",
	"./unidad2/pantalla 7-1.svg": "6fda",
	"./unidad2/pantalla 7-11.svg": "5323"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d20d";